import React from 'react';
import IDAustriaButton from './IDAustriaButton';
import PhotoIdentButton from './PhotoIdentButton';
import BankIdent from './BankIdent';
import { useAppTranslation } from '../../../i18n';
import { Header } from '../blank-check-input-step/Header';
import { useAppSelector } from '../../../app/hooks';
import { selectCheckFlagsWithIDAustria, selectCheckFlagsWithPhotoIdent } from '../../../app/slices/flags.slice';

const TRANSLATION_PREFIX = 'steps.bank-auth-type-selection';

export const BankAuthTypeSelection = () => {
	const { t } = useAppTranslation();
	const idAustriaEnabled = Boolean(useAppSelector(selectCheckFlagsWithIDAustria));
	const photoIdentEnabled = Boolean(useAppSelector(selectCheckFlagsWithPhotoIdent));
	const bankProcessFinished = useAppSelector((state) => state.ui.bankProcessFinished);

	const methods = bankProcessFinished
		? [photoIdentEnabled && <PhotoIdentButton key="photo-ident" />].filter(Boolean)
		: [
				idAustriaEnabled && <IDAustriaButton key="id-austria" />,
				<BankIdent key="bank-ident" />,
				photoIdentEnabled && <PhotoIdentButton key="photo-ident" />
			].filter(Boolean);

	const titleKey = bankProcessFinished ? 'required-title' : 'selection-title';
	const descriptionKey = bankProcessFinished ? 'required-description' : 'selection-description';

	return (
		<div
			id="bank-auth-type-step"
			className="bank-auth-type-selection-step flex flex-col items-start gap-6 w-full"
		>
			<div className="-my-8 custom-small:-ml-5">
				<Header />
			</div>

			<div className="flex flex-col items-start gap-1 mt-6">
				<h2 className="text-2xl font-[700] text-gray-800 leading-tight">
					{t(`${TRANSLATION_PREFIX}.${titleKey}`)}
				</h2>
				<p className="text-sm text-gray-500">{t(`${TRANSLATION_PREFIX}.${descriptionKey}`)}</p>
			</div>

			<div className="flex flex-col items-stretch gap-4 w-full">{methods}</div>
		</div>
	);
};

export default BankAuthTypeSelection;
